import { useTranslation } from 'react-i18next';

import type { FC } from 'react';

import { Button } from '@/components/ui/button';

interface FilterFooterProps {
  onClear: () => void;
  onApply: () => void;
  count: number;
}

const getBtnClass = () =>
  'size-8 min-h-9 py-2 flex items-center justify-center gap-2 grow cursor-pointer rounded-lg shadow-xs font-medium text-sm';

const FilterFooter: FC<FilterFooterProps> = ({ onClear, onApply, count }) => {
  const { t } = useTranslation();
  const isClearable = count > 0;

  return (
    <div className="flex items-center gap-2 py-2 px-4">
      <Button
        className={`${getBtnClass()} hover:bg-white`}
        aria-label="clear-all-filter"
        disabled={!isClearable}
        onClick={onClear}
      >
        {t('filters.clear_all')}
      </Button>
      <Button
        className={`${getBtnClass()} bg-primary text-white hover:bg-primary hover:text-white`}
        aria-label="apply-filter"
        onClick={onApply}
      >
        {t('filters.apply')}
      </Button>
    </div>
  );
};

export default FilterFooter;
